module.exports = __webpack_public_path__ + "img/tradecommencementmeetings_twitter.4c6f2b98.png";